import { fmtDT } from "@/lib/format";

export const errMsg = (e, f) => (typeof e.response?.data?.detail === "string" ? e.response.data.detail : f);
export const n = (v) => (v ?? 0).toLocaleString("en-IN");
export const money = (v) => (v == null ? "—" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`);

export function Tbl({ head, children, testid, empty }) {
  const rows = Array.isArray(children) ? children.filter(Boolean) : children ? [children] : [];
  return (
    <div className="bg-card border border-border rounded-lg overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead><tr className="border-b border-border text-left">
          {head.map((h) => <th key={h} className="px-3 py-2 text-[10px] font-mono uppercase tracking-widest text-muted-foreground whitespace-nowrap">{h}</th>)}
        </tr></thead>
        <tbody>
          {rows.length ? rows : <tr><td colSpan={head.length} className="px-4 py-6 text-center text-sm text-muted-foreground">{empty || "None"}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function KV({ k, v, testid }) {
  return (
    <div data-testid={testid}>
      <p className="text-[9px] font-mono uppercase tracking-widest text-muted-foreground">{k}</p>
      <p className="text-sm font-medium mt-0.5 break-words">{v === null || v === undefined || v === "" ? "—" : String(v)}</p>
    </div>
  );
}

export function Status({ s }) {
  const c = ["approved", "executed", "completed", "active", "released", "passed"].includes(s) ? "text-signal-green" : ["pending", "requested", "in_transit"].includes(s) ? "text-signal-amber" : ["rejected", "cancelled", "failed", "archived"].includes(s) ? "text-signal-red" : "";
  return <span className={`text-[10px] font-mono uppercase ${c}`}>{s || "—"}</span>;
}

export const DT = ({ v }) => <span className="metric text-xs whitespace-nowrap">{v ? fmtDT(v) : "—"}</span>;
